"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrimitiveRole = exports.PrimitiveType = void 0;
var PrimitiveType;
(function (PrimitiveType) {
    PrimitiveType[PrimitiveType["Circle"] = 0] = "Circle";
    PrimitiveType[PrimitiveType["Oblong"] = 1] = "Oblong";
    PrimitiveType[PrimitiveType["Rectangle"] = 2] = "Rectangle";
    PrimitiveType[PrimitiveType["RoundedRectangle"] = 3] = "RoundedRectangle";
    PrimitiveType[PrimitiveType["Line"] = 4] = "Line";
    PrimitiveType[PrimitiveType["LineArc"] = 5] = "LineArc";
    PrimitiveType[PrimitiveType["Union"] = 6] = "Union";
    PrimitiveType[PrimitiveType["Difference"] = 7] = "Difference";
    PrimitiveType[PrimitiveType["ApproxPolygon"] = 8] = "ApproxPolygon";
    PrimitiveType[PrimitiveType["Expansion"] = 9] = "Expansion";
})(PrimitiveType || (exports.PrimitiveType = PrimitiveType = {}));
var PrimitiveRole;
(function (PrimitiveRole) {
    PrimitiveRole[PrimitiveRole["silkScreen"] = 0] = "silkScreen";
    PrimitiveRole[PrimitiveRole["metaData"] = 1] = "metaData";
    PrimitiveRole[PrimitiveRole["copper"] = 2] = "copper";
    PrimitiveRole[PrimitiveRole["solderPaste"] = 3] = "solderPaste";
    PrimitiveRole[PrimitiveRole["solderMaskOpening"] = 4] = "solderMaskOpening";
    PrimitiveRole[PrimitiveRole["layoutHole"] = 5] = "layoutHole";
    PrimitiveRole[PrimitiveRole["zone"] = 6] = "zone";
    PrimitiveRole[PrimitiveRole["polygonOutline"] = 7] = "polygonOutline";
    PrimitiveRole[PrimitiveRole["other"] = 8] = "other";
})(PrimitiveRole || (exports.PrimitiveRole = PrimitiveRole = {}));
//# sourceMappingURL=primitives.js.map